import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

// Applies to every owl-date-time input app-wide: blocks free typing (which the
// picker library parses leniently, e.g. "1" silently becomes Jan 1) so a date
// can only be picked from the calendar, while keeping the normal input look via
// the date-picker-input class (see input.date-picker-input[readonly] in tailwind.css).
@Directive({
  selector: 'input[owlDateTime]'
})
export class DatePickerReadonlyDirective implements AfterViewInit {

  constructor(private el: ElementRef<HTMLInputElement>, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'readonly', 'true');
    this.renderer.addClass(this.el.nativeElement, 'date-picker-input');
  }
}
